import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import TitleUpdater from "../../components/common/title/TitleUpdater";
import AuditOverview from "../../components/dashboard-statistics/audit-overview/AuditOverview";
import StoresMap from "../../components/dashboard-statistics/stores-map/StoresMap";
import { useAuth } from "../../context/AuthContext";

const Dashboard = () => {
  const { t } = useTranslation("translation");
  const { setButtons } = useAuth();
  useEffect(() => {
    setButtons([]);
    return () => setButtons([]);
  }, [setButtons]);
  return (
    <div>
      <TitleUpdater title={t("dashboard.title")} />
      <AuditOverview filters={{ storeId: "", startDate: "", endDate: "" }} />
      <StoresMap />
    </div>
  );
};

export default Dashboard;
